var App = App || {};

App.TaxonomyFacet = (function () {

    return {
        init: init,
        updateTaxonomyTreeModal: updateTaxonomyTreeModal,
        getTaxonomyUrl: getTaxonomyUrl,
        getAlertModalTaxonomyUrl: getAlertModalTaxonomyUrl,
        getAlertModalSeriesTaxonomyUrl: getAlertModalSeriesTaxonomyUrl,
        initTaxonomyTree: initTaxonomyTree,
        initTaxonomyArrows: initTaxonomyArrows,
        taxonomyFilterFunction: taxonomyFilterFunction
    };

    function init() {
        if (!_myComponentIsOnPage()) {
            return;
        }
    }

    function _myComponentIsOnPage() {
        return $('.js-taxonomy-tree-wrap').length;
    }

    function updateTaxonomyTreeModal($taxonomyElement) {
        var $checkBoxContainer = $taxonomyElement.closest('.js-taxonomy-child-list-item');
        SCM.CollectionFacet.updateFacetDescendantCheckboxes($taxonomyElement, $checkBoxContainer, '.js-taxonomy-checkbox');
        toggleTaxonomyParent();
    }

    function getTaxonomyUrl($taxonomyElement) {
        var curTaxonomyNodeId = '';
        var taxEqualsKey;
        var taxKey;

        if ($taxonomyElement.hasClass('js-taxonomy-checkbox') || $taxonomyElement.hasClass('checkbox-label')) {
            taxEqualsKey = 'taxWithOr=';
            taxKey = 'taxWithOr';

            var $checkBoxContainer = $taxonomyElement.closest('.js-taxonomy-child-list-item');
            SCM.CollectionFacet.updateFacetDescendantCheckboxes($taxonomyElement, $checkBoxContainer, '.js-taxonomy-checkbox');

            var selectedTaxIds = [];
            $taxonomyElement.closest('.js-taxonomy-tree-wrap').find('.js-taxonomy-checkbox:checked').each(function () {
                var $parent = $(this).parents('.js-parent');
                if ($parent.length) {
                    var $parentCheckbox = $parent.find('.js-taxonomy-checkbox:first:checked');
                    if ($parentCheckbox.length) {
                        var dataId = $parentCheckbox.attr('data-id');
                        if ($.inArray(dataId, selectedTaxIds)) {
                            selectedTaxIds.push(dataId);
                        }
                    }
                    else {
                        selectedTaxIds.push($(this).attr('data-id'));
                    }
                }
            });
            curTaxonomyNodeId = selectedTaxIds.toString();
            if (curTaxonomyNodeId.endsWith(',')) {
                curTaxonomyNodeId = curTaxonomyNodeId.slice(0, -1);
            }
        }
        else {
            taxEqualsKey = 'tax=';
            taxKey = 'tax';
            curTaxonomyNodeId = $taxonomyElement.parent('.taxonomy-label-wrap').attr('data-id');
        }
        var currentDataUrl = $('#TaxonomyCurrentDataUrl').val();
        currentDataUrl = decodeURIComponent(currentDataUrl);

        var params = currentDataUrl.split('&');
        // Remove existing tax query and re-add later
        params = $.grep(params, function (item, i) {
            return !item.startsWith(taxEqualsKey);
        });

        //get root node
        var rootNodeId = $taxonomyElement.closest('.taxonomy-node').attr('data-id');

        //check if any taxonomy filters have been applied already.
        var taxQsPos = currentDataUrl.indexOf(taxEqualsKey);
        var taxQsPresent = (taxQsPos === -1) ? false : true;

        if (!taxQsPresent || taxKey === 'taxWithOr') {
            //filter applied for the first time.
            currentDataUrl = params.join('&');
            if (curTaxonomyNodeId.length) {
                currentDataUrl += '&' + taxEqualsKey + curTaxonomyNodeId;
            }
        } else {
            //taxonomy filter applied previously
            var taxQueryTerm = decodeURIComponent(SCM.JSUtility.getSearchParamByName(taxKey));
            if (taxQueryTerm && taxQueryTerm !== '') {
                //check if taxonomy query was executed via Subject Dropdown, which is based on the rootNode.
                if (taxQueryTerm.indexOf('=' + rootNodeId) > -1) {
                    //remove the root node and just use the selected node to expedite the query execution
                    currentDataUrl = currentDataUrl.replace(taxEqualsKey + taxQueryTerm, taxEqualsKey + curTaxonomyNodeId);

                } else if ($.inArray(curTaxonomyNodeId, decodeURIComponent(taxQueryTerm
                    .slice(4))
                    .split(',')) === -1) {
                    //taxonomy query was executed from the facet section and has not already been selected
                    var newQuery = taxQueryTerm + ',' + curTaxonomyNodeId;
                    currentDataUrl = currentDataUrl.replace(taxQueryTerm, newQuery);
                }
            }
        }

        return currentDataUrl;
    }

    function getAlertModalTaxonomyUrl() {
        // Select all the .js-taxonomy-tree-wrap elements without series
        var $taxonomyWrappers = $('.js-taxonomy-tree-wrap[data-is-series="false"]');
        var taxonomyIdsString = getSelectedTaxonomies($taxonomyWrappers);
        var currentDataUrl = updateQueryStringParam('tax', taxonomyIdsString);

        return currentDataUrl;
    }

    function getAlertModalSeriesTaxonomyUrl() {
        // Select all the .js-taxonomy-tree-wrap elements with series
        var $taxonomyWrappers = $('.js-taxonomy-tree-wrap[data-is-series="true"]');
        var taxonomyIdsString = getSelectedTaxonomies($taxonomyWrappers);
        var currentDataUrl = updateQueryStringParam('taxWithOr', taxonomyIdsString);

        return currentDataUrl;
    }

    function getSelectedTaxonomies($taxonomyWrappers) {
        // Find all checked taxonomies within these wrappers
        var taxonomies = $taxonomyWrappers.find('.js-taxonomy-checkbox:checked');
        var taxonomiesFiltered = taxonomies.filter(taxonomyFilterFunction);
        var taxonomyIds = SCM.SiteJS.processTaxonomies(taxonomiesFiltered);
        var taxonomyIdsString = taxonomyIds.join(',');
        return taxonomyIdsString
    }

    function updateQueryStringParam(param, value) {
        var currentUrl = window.location.href;
        var url = new URL(currentUrl);
        var params = new URLSearchParams(url.search);

        if (value) {
            params.set(param, value);
        } else {
            params.delete(param);
        }

        url.search = params.toString();
        var newUrl = url.toString();
        return newUrl;
    }

    function initTaxonomyTree() {
        $('.js-taxonomy-tree-wrap').find('.js-taxonomy-checkbox').each(function () {
            var $checkbox = $(this);
            if ($checkbox.prop('checked')) {
                checkChildCheckboxes($checkbox);
            }
        });
        toggleTaxonomyParent();
    }

    function checkChildCheckboxes($parentCheckbox) {
        var $childListItems = $parentCheckbox.closest('.js-taxonomy-child-list-item').find('.js-taxonomy-child-list .js-taxonomy-checkbox');
        $childListItems.prop('checked', true);
    }

    function toggleTaxonomyParent() {
        $checkedItems = $('.js-taxonomy-checkbox:checked');
        if ($checkedItems.length > 0) {
            $checkedItems.parents('.js-taxonomy-child-list-item').each(function () {
                expandChildList($(this));
            });
        }
    }

    function expandChildList($childListItem) {
        var $arrowLink = $childListItem.find('.js-taxonomy-parent-arrow').first();
        var $icon = $arrowLink.children('.js-taxonomy-icon');
        if ($arrowLink && $arrowLink.length && $icon.hasClass('icon-general-arrow-filled-right')) {
            $arrowLink.closest('.js-taxonomy-child-list-item').children('.js-taxonomy-child-list').toggleClass('hide');
            $icon.removeClass('icon-general-arrow-filled-right').addClass('icon-general-arrow-filled-down');
        }
    }

    function initTaxonomyArrows(parentWindow) {
        parentWindow.find('.js-taxonomy-parent-arrow').on('click', function () {
            var $this = $(this);

            $this.parents('.js-taxonomy-label-wrap').siblings('.js-taxonomy-child-list').toggleClass('hide');

            var $icon = $this.children('.js-taxonomy-icon');
            $icon.hasClass('icon-general-arrow-filled-right')
                ? $icon.removeClass('icon-general-arrow-filled-right').addClass('icon-general-arrow-filled-down')
                : $icon.removeClass('icon-general-arrow-filled-down').addClass('icon-general-arrow-filled-right');
        });

        parentWindow.find('.js-taxonomy-checkbox').on('click', function () {
            var parentContainer;

            if ($(this).is(':checked')) {
                // check all descendants
                parentContainer = $(this).parent().parent();
                parentContainer.find('.js-taxonomy-checkbox').prop('checked', true);
            }
            else {
                // uncheck all descendants
                parentContainer = $(this).parent().parent();
                parentContainer.find('.js-taxonomy-checkbox').prop('checked', false);

                // uncheck toplevel node (special case)
                $(this).closest('.js-taxonomy-node').children('.js-taxonomy-parent-label').find('.js-taxonomy-checkbox').prop('checked', false);

                // uncheck parent nodes that aren't the toplevel node
                $(this).parents('.js-taxonomy-child-list-item').children('.js-taxonomy-parent-label').find('.js-taxonomy-checkbox').prop('checked', false);
            }
        });
    };

    function taxonomyFilterFunction() {
        return $(this).parents('.js-taxonomy-child-list-item').parents('.js-taxonomy-child-list-item').children('.js-taxonomy-parent-label').find('.js-taxonomy-checkbox:checked').length < 1;
    };

})(jQuery);